const Asciicheck = (event) => {
  const eventCreated = event;

  let { value } = eventCreated.target;
  const combining = /[\u0300-\u036F]/g;
  if (typeof value === 'string') value = value.normalize('NFKD').replace(combining, '');

  eventCreated.target.value = value;
  return eventCreated;
};

export default Asciicheck;
